exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.no-bullets{list-style-type:none;margin:0;padding:0}.scrollView::-webkit-scrollbar{display:none;overflow:scroll}.scrollView{-ms-overflow-style:none;scrollbar-width:none;overflow:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69cdd1b0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Sidebar.vue
// module id = 278
// module chunks = 0